import React, { FC } from "react";

interface LogoProps {
  color?: string;
  height: number;
}

export const Logo: FC<LogoProps> = ({ color = "white", height }) => {
  return (
    <svg
      fill={color}
      viewBox="0 0 1258.58 187.09"
      xmlns="http://www.w3.org/2000/svg"
      height={height}
    >
      <g>
        <path
          d="M5.67,35.47v25.95c0.14-0.02,0.28-0.03,0.42-0.05c18.68-2.2,35.11,12.4,35.11,31.21v88.79h25.73V81.2
		c0-15.35,11.66-28.23,27-29.69c14.3-1.37,26.03,9.69,26.03,24.05v105.8h25.73V78.51c0-18.71,14.1-34.42,32.72-36.43
		c17.38-1.87,32.44,12.05,32.44,29.53v109.75h25.73V71.73c0-20.47,15.24-37.65,35.53-40.11V5.73L5.67,35.47z"
        />
        <g>
          <polygon
            points="728.53,46.67 728.53,46.69 728.53,140.07 728.53,140.1 806.76,140.1 806.76,123.31 754.24,123.31 754.24,101.75
			796.02,101.75 796.02,84.96 754.24,84.96 754.24,63.48 806.76,63.48 806.76,46.69 754.24,46.67 		"
          />
          <path d="M939.37,140.07h0.09c0,0.02,0,0.04,0,0.06c8.53,0,16.96,0,25.54,0c0-0.02,0-0.04,0-0.06h0.09v-93.4h-25.71V140.07z" />
          <path
            d="M393.22,46.67h-69.69v93.4h25.71v-30.77h43.98c17.29,0,31.31-14.02,31.31-31.31C424.53,60.69,410.51,46.67,393.22,46.67z
			 M384.32,92.48h-35.08V63.48h35.08c8.01,0,14.5,6.49,14.5,14.5C398.82,85.99,392.33,92.48,384.32,92.48z"
          />
          <path
            d="M918.54,77.98c0-17.29-14.02-31.31-31.31-31.31h-60.87v93.4h25.71v-30.77h16.95l23.37,30.77h31.08l-24.98-32.89
			C910.21,102.65,918.54,91.3,918.54,77.98z M878.33,92.47h-26.26V63.48h26.26c8.01,0,14.5,6.49,14.5,14.5
			S886.34,92.47,878.33,92.47z"
          />
          <path
            d="M510.96,44.3h-35.03c-22.12,0-40.21,18.09-40.21,40.21v18.07c0,22.11,18.09,40.21,40.21,40.21h35.03
			c22.12,0,40.21-18.09,40.21-40.21V84.51C551.17,62.39,533.08,44.3,510.96,44.3z M524.74,100.25c0,13.2-10.8,24-24,24h-14.59
			c-13.2,0-24-10.8-24-24V86.83c0-13.2,10.8-24,24-24h14.59c13.2,0,24,10.8,24,24V100.25z"
          />
          <path
            d="M1064.77,99.58c0,11.87-8.37,21.59-18.59,21.59h-11.3c-10.23,0-18.6-9.72-18.6-21.59V46.67h-25.46v55.91
			c0,22.11,15.58,40.21,34.63,40.21h30.16c19.05,0,34.63-18.09,34.63-40.21V46.67h-25.46V99.58z"
          />
          <path
            d="M709,140.07c-3.83-31.18-7.82-62.22-11.65-93.4c-0.3-0.02-29.57,0-29.57,0l-30.15,64.43l-30.15-64.43
			c0,0-29.26-0.02-29.57,0c-3.83,31.19-7.82,62.23-11.65,93.4h23.94c2.42-20.36,5.07-40.17,7.56-60.4
			c7.07,15.1,20.51,43.81,28.27,60.4h23.22l28.27-60.4c2.49,20.23,5.13,40.04,7.56,60.4H709z"
          />
          <path
            d="M1252.91,140.07c-3.83-31.18-7.82-62.22-11.65-93.4c-0.3-0.02-29.57,0-29.57,0l-30.15,64.43l-30.15-64.43
			c0,0-29.26-0.02-29.57,0c-3.83,31.19-7.82,62.23-11.65,93.4h23.94c2.42-20.36,5.07-40.17,7.56-60.4
			c7.07,15.1,20.51,43.81,28.27,60.4h23.22l28.27-60.4c2.49,20.23,5.13,40.04,7.56,60.4H1252.91z"
          />
        </g>
      </g>
    </svg>
  );
};
